var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7,20V9c0-0.5,0.2-1,0.6-1.4C8,7.2,8.5,7,9,7h11c0.6,0,1,0.2,1.4,0.6C21.8,8,22,8.4,22,9v11c0,1.1-0.9,2-2,2h-3H9 c-0.6,0-1-0.2-1.4-0.6S7,20.5,7,20z M2,6.2c-0.1-0.5,0-1,0.3-1.5S3.1,4,3.7,3.9L14.5,2c0.6-0.1,1,0,1.5,0.3c0.4,0.3,0.7,0.8,0.8,1.3 L17.1,5H15l-0.2-1L4,5.9l1,5.7v7c-0.3-0.1-0.5-0.3-0.7-0.6C4.1,17.7,4,17.4,4,17.1L2,6.2z M9,9v11h7h4V9H9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabIcon);
export default __webpack_public_path__ + "static/media/tab-icon.a7929de86370ddc4c2369e5000bf235b.svg";
export { ForwardRef as ReactComponent };